/**
 * Local Delivery - localStorage persistence
 */
(function () {
  'use strict';

  var KEY = 'wf-ld-state';

  function load() {
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function save(state) {
    try {
      localStorage.setItem(KEY, JSON.stringify(state || {}));
    } catch (e) {}
  }

  function clear() {
    try { localStorage.removeItem(KEY); } catch (e) {}
  }

  window.WF_LD_STORAGE = {
    load: load,
    save: save,
    clear: clear,
  };
})();
